import { useCallback } from 'react';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { getInventorySources } from '../services/api';

/**
 * @typedef {{
 * inventorySourceGuid: string,
 * inventorySourceType: "Native" | "Store"
 * sellerInventoryPartnetId: string,
 * warehouseGroupName: string,
 * warehouses: {
 *  name: string,
 *  inventorySourceId: string,
 *  inventorySourceExternalId: string,
 *  inventorySourceGuid: string,
 *  warehouseType: "Individual" | "Aggregate",
 *  createDate: string,
 * }
 *  }} InventorySource
 */

/**
 * @returns {{isLoading: boolean, errors: Array, fetch: Function, sources: Array<InventorySource>}} An object containing the inventory sources, loading state, and errors.
 */
export const useInventorySources = () => {
  const [sources, setSources] = useAsyncSafeState([]);
  const [isLoading, setIsLoading] = useAsyncSafeState(true);
  const [errors, setErrors] = useAsyncSafeState([]);

  const fetch = useCallback(async () => {
    setIsLoading(true);
    setErrors([]);
    setSources([]);

    try {
      const response = await getInventorySources();
      setSources(response);
    } catch (error) {
      setErrors([error]);
    } finally {
      setIsLoading(false);
    }
  }, [setErrors, setIsLoading, setSources]);

  return {
    fetch,
    sources,
    isLoading,
    errors,
  };
};
